import { Shield } from "lucide-react";
import { Link, useLocation } from "react-router";
import { buttonClassName } from "@client/components/ui/button-variants";
import { useAuth } from "@client/hooks/use-auth";
import { authCopy } from "@client/locales/id/auth";
import { commonCopy } from "@client/locales/id/common";
import { MainNav } from "./MainNav";
import { UserMenu } from "./UserMenu";

/** Sticky frosted header: brand, main navigation, and the account area. */
export function SiteHeader() {
  const { status, user, viewMode } = useAuth();
  const location = useLocation();
  const loginHref = `/login?redirect=${encodeURIComponent(`${location.pathname}${location.search}`)}`;

  return (
    <header className="sticky top-0 z-40 border-b border-border-default bg-background-base/70 backdrop-blur-xl">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <Link to="/" className="flex min-h-11 items-center gap-2.5" aria-label={commonCopy.brand}>
          <img src="/logo.png" alt="" width={28} height={28} className="size-7 rounded-md" />
          <span className="text-sm font-semibold tracking-tight text-foreground">{commonCopy.brand}</span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          <MainNav />
          {viewMode === "admin" && (
            <Link
              to="/admin"
              className="hidden items-center gap-1.5 rounded-full border border-border-accent bg-accent-soft px-3 py-1 font-mono text-xs tracking-widest text-foreground uppercase sm:inline-flex"
            >
              <Shield className="size-3.5 text-accent-bright" aria-hidden="true" />
              {authCopy.menu.adminBadge}
            </Link>
          )}
          {status === "loading" && <span className="size-8 animate-pulse rounded-full bg-surface" />}
          {status === "anonymous" && location.pathname !== "/login" && (
            <Link to={loginHref} className={buttonClassName("secondary", "md")}>
              {authCopy.menu.signIn}
            </Link>
          )}
          {status === "authenticated" && user && <UserMenu user={user} />}
        </div>
      </div>
    </header>
  );
}
